import { render, staticRenderFns } from "./OwnerIdeaDetailPage.vue?vue&type=template&id=0b360b86&"
import script from "./OwnerIdeaDetailPage.vue?vue&type=script&lang=ts&"
export * from "./OwnerIdeaDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports